(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["starbond-cart-confirmation"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('starbond-cart-confirmation')) return;

    class StarbondCartConfirmation extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.panel = this.querySelector('.sb-cart-confirmation__panel');
        this.cartLink = this.querySelector('.sb-cart-confirmation__cart');
        this.status = this.querySelector('[data-confirmation-status]');
        this.message = this.querySelector('[data-confirmation-message]').textContent.trim();
        this.mobileQuery = window.matchMedia('(max-width: 767px)');
        this.pauseReasons = new Set();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.querySelector('[data-confirmation-close]').addEventListener('click', () => this.hide(true), options);
        this.cartLink.addEventListener('click', () => this.hide(false), options);
        this.panel.addEventListener('pointerenter', () => this.pause('hover'), options);
        this.panel.addEventListener('pointerleave', () => this.resume('hover'), options);
        this.panel.addEventListener('focusin', () => this.pause('focus'), options);
        this.panel.addEventListener('focusout', (event) => {
          if (!this.panel.contains(event.relatedTarget)) this.resume('focus');
        }, options);
        this.panel.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !this.panel.contains(document.activeElement)) return;
          event.preventDefault();
          event.stopPropagation();
          this.hide(true);
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.pause('background');
          else this.resume('background');
        }, options);
        window.addEventListener('resize', () => this.schedulePosition(), options);
        window.addEventListener('scroll', () => this.schedulePosition(), { ...options, passive: true });
        this.mobileQuery.addEventListener('change', () => this.schedulePosition(), options);
        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', () => this.schedulePosition(), options);
          window.visualViewport.addEventListener('scroll', () => this.schedulePosition(), options);
        }
      }

      disconnectedCallback() {
        this.hide(false);
        clearTimeout(this.announcementTimer);
        this.events && this.events.abort();
        this.events = null;
      }

      show({ product, trigger } = {}) {
        if (!product || !this.panel || !this.isConnected) return false;
        this.returnTarget = trigger instanceof HTMLElement ? trigger : document.activeElement;
        this.panel.hidden = false;
        this.remaining = 5000;
        clearTimeout(this.dismissTimer);
        this.dismissTimer = null;
        if (this.panel.contains(document.activeElement)) this.pauseReasons.add('focus');
        else this.pauseReasons.delete('focus');
        if (document.hidden) this.pauseReasons.add('background');
        else this.pauseReasons.delete('background');
        this.observeLayout();
        this.position();
        this.startTimer();
        clearTimeout(this.announcementTimer);
        this.status.textContent = '';
        this.announcementTimer = setTimeout(() => {
          const title = String(product.product_title || product.title || '').trim();
          this.status.textContent = this.message + (title ? ': ' + title : '');
        }, 50);
        return true;
      }

      hide(restoreFocus = false) {
        if (!this.panel) return;
        const hadFocus = this.panel.contains(document.activeElement);
        this.panel.hidden = true;
        clearTimeout(this.dismissTimer);
        this.dismissTimer = null;
        cancelAnimationFrame(this.positionFrame);
        this.positionFrame = null;
        if (this.layoutObserver) this.layoutObserver.disconnect();
        if (this.obstacleObserver) this.obstacleObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.observed = new Set();
        this.pauseReasons.clear();
        if (restoreFocus && hadFocus && this.returnTarget instanceof HTMLElement && this.returnTarget.isConnected && !this.returnTarget.closest('[hidden], [inert]')) {
          this.returnTarget.focus({ preventScroll: true });
        }
      }

      startTimer() {
        if (this.panel.hidden || this.pauseReasons.size || this.dismissTimer) return;
        this.timerStarted = Date.now();
        this.dismissTimer = setTimeout(() => this.hide(false), Math.max(0, this.remaining));
      }

      pause(reason) {
        if (this.panel.hidden) return;
        this.pauseReasons.add(reason);
        if (!this.dismissTimer) return;
        this.remaining = Math.max(0, this.remaining - (Date.now() - this.timerStarted));
        clearTimeout(this.dismissTimer);
        this.dismissTimer = null;
      }

      resume(reason) {
        this.pauseReasons.delete(reason);
        this.startTimer();
      }

      schedulePosition() {
        if (this.panel.hidden || this.positionFrame) return;
        this.positionFrame = requestAnimationFrame(() => {
          this.positionFrame = null;
          if (!this.panel.hidden) this.position();
        });
      }

      observeLayout() {
        this.observed = this.observed || new Set();
        this.layoutObserver = this.layoutObserver || new MutationObserver((changes) => {
          if (changes.some((change) => !this.contains(change.target))) this.schedulePosition();
        });
        this.layoutObserver.observe(document.body, { childList: true, subtree: true });
        this.obstacleObserver = this.obstacleObserver || new MutationObserver(() => this.schedulePosition());
        if (window.ResizeObserver) {
          this.resizeObserver = this.resizeObserver || new ResizeObserver(() => this.schedulePosition());
          this.resizeObserver.observe(this.panel);
        }
      }

      observeObstacle(element) {
        if (!element || this.observed.has(element)) return;
        this.observed.add(element);
        this.obstacleObserver.observe(element, { attributes: true, childList: true, subtree: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
        if (this.resizeObserver && element instanceof Element) this.resizeObserver.observe(element);
      }

      visibleBounds(element) {
        if (!element || element.closest('[hidden]')) return null;
        const bounds = element.getBoundingClientRect();
        const style = getComputedStyle(element);
        return bounds.width > 0 && bounds.height > 0 && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity || 1) > 0 ? bounds : null;
      }

      hostIsVisible(element) {
        if (!element || element.closest('[hidden]')) return false;
        const style = getComputedStyle(element);
        return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity || 1) > 0;
      }

      position() {
        const viewport = window.visualViewport;
        const viewportTop = viewport ? viewport.offsetTop : 0;
        const viewportLeft = viewport ? viewport.offsetLeft : 0;
        const viewportHeight = viewport ? viewport.height : window.innerHeight;
        const viewportWidth = viewport ? viewport.width : window.innerWidth;
        const mobile = this.mobileQuery.matches;
        const safeTop = viewportTop + Math.max(12, parseFloat(getComputedStyle(this).paddingTop) || 0);
        let safeBottom = viewportTop + viewportHeight - 12;
        const width = Math.max(0, Math.min(mobile ? 420 : 340, viewportWidth - 32));
        this.style.setProperty('--sb-confirmation-width', width + 'px');
        const rewardsHost = document.getElementById('smile-ui-container');
        const rewards = rewardsHost && rewardsHost.querySelector('.smile-launcher-frame-container');
        const cookieHost = document.querySelector('csm-cookie-consent');
        const cookieShadow = cookieHost && cookieHost.shadowRoot;
        const cookieBanner = cookieShadow && cookieShadow.querySelector('.csm-cmp-bar.cc-bottom');
        [rewardsHost, rewards, cookieHost, cookieShadow].forEach((element) => this.observeObstacle(element));
        [this.hostIsVisible(rewardsHost) ? rewards : null, this.hostIsVisible(cookieHost) ? cookieBanner : null].forEach((element) => {
          const bounds = this.visibleBounds(element);
          if (bounds && bounds.right > viewportLeft && bounds.left < viewportLeft + viewportWidth && bounds.top > safeTop && bounds.top < safeBottom) safeBottom = Math.min(safeBottom, bounds.top - 12);
        });
        this.style.setProperty('--sb-confirmation-height', Math.max(58, safeBottom - safeTop) + 'px');
        let preferredTop = safeTop;
        let left = viewportLeft + (viewportWidth - width) / 2;
        if (mobile) {
          document.querySelectorAll('header').forEach((header) => {
            this.observeObstacle(header);
            const bounds = this.visibleBounds(header);
            if (bounds && bounds.top < viewportTop + viewportHeight && bounds.bottom > viewportTop && bounds.bottom < safeBottom) preferredTop = Math.max(preferredTop, bounds.bottom + 8);
          });
        } else {
          const cartPath = new URL(this.cartLink.href, window.location.origin).pathname;
          const headerCart = Array.from(document.querySelectorAll('a.cart-icon[href], header a[href]')).find((link) => {
            const bounds = this.visibleBounds(link);
            try {
              return bounds && bounds.bottom > viewportTop && bounds.bottom < safeBottom && new URL(link.href, window.location.origin).pathname === cartPath;
            } catch (error) { return false; }
          });
          const anchor = this.visibleBounds(headerCart);
          if (headerCart) this.observeObstacle(headerCart.closest('header') || headerCart);
          preferredTop = anchor ? anchor.bottom + 8 : safeTop;
          left = anchor ? anchor.right - width : viewportLeft + viewportWidth - width - 24;
        }
        const panelHeight = this.panel.getBoundingClientRect().height;
        const top = Math.max(safeTop, Math.min(preferredTop, safeBottom - panelHeight));
        left = Math.max(viewportLeft + 16, Math.min(left, viewportLeft + viewportWidth - width - 16));
        this.style.setProperty('--sb-confirmation-top', top + 'px');
        this.style.setProperty('--sb-confirmation-left', left + 'px');
        this.style.setProperty('--sb-confirmation-right', 'auto');
      }
    }

    customElements.define('starbond-cart-confirmation', StarbondCartConfirmation);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["starbond-continue-shopping"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.sbContinueShoppingReady) return;
    const configElement = document.getElementById('SbContinueShoppingConfig');
    if (!configElement) return;

    let config;
    try {
      config = JSON.parse(configElement.textContent);
    } catch (_) {
      return;
    }
    window.sbContinueShoppingReady = true;

    const storageKey = 'starbond:last-shopping-page:v1';
    const selector = '[data-sb-continue-shopping]';
    const shoppingTypes = new Set(['index', 'product', 'collection', 'list-collections', 'search', 'page', 'blog', 'article']);
    const rootPath = new URL(config.rootUrl || '/', window.location.origin).pathname.replace(/\/$/, '');
    let remembered = '';

    const safeShoppingUrl = (value) => {
      if (typeof value !== 'string' || !value || /[\\\u0000-\u001f\u007f]/.test(value)) return '';
      try {
        const url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin || !/^https?:$/.test(url.protocol) || url.username || url.password) return '';
        if (/%(?:2f|5c|25)/i.test(url.pathname)) return '';
        let path = decodeURIComponent(url.pathname);
        if (/[\\\u0000-\u001f\u007f]/.test(path)) return '';
        if (rootPath && (path === rootPath || path.startsWith(rootPath + '/'))) path = path.slice(rootPath.length) || '/';
        if (!/^(?:\/|\/collections\/?|\/collections\/[^/.]+(?:\/[^/.]+|\/products\/[^/.]+)?\/?|\/products\/[^/.]+\/?|\/search\/?|\/pages\/[^/.]+\/?|\/blogs\/[^/.]+(?:\/[^/.]+|\/tagged\/[^/.]+)?\/?)$/.test(path)) return '';
        for (const key of url.searchParams.keys()) {
          if (/^(?:_method|method|action|checkout|return_to|return_url|redirect|redirect_url|section_id|sections)$/i.test(key)) return '';
        }
        return url.pathname + url.search + url.hash;
      } catch (_) {
        return '';
      }
    };

    const rememberCurrentPage = () => {
      if (!shoppingTypes.has(config.pageType)) return;
      const value = safeShoppingUrl(window.location.href);
      if (!value) return;
      remembered = value;
      try {
        window.sessionStorage.setItem(storageKey, value);
      } catch (_) {}
    };

    const returnUrl = () => {
      let saved = remembered;
      try {
        saved = window.sessionStorage.getItem(storageKey) || saved;
      } catch (_) {}
      return safeShoppingUrl(saved) || safeShoppingUrl(document.referrer) || config.fallbackUrl;
    };

    const updateLinks = () => {
      const url = returnUrl();
      document.querySelectorAll(selector).forEach((link) => link.setAttribute('href', url));
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest?.('a');
      if (!link) return;
      if (link.matches(selector)) {
        link.setAttribute('href', returnUrl());
        return;
      }
      try {
        const url = new URL(link.href, window.location.origin);
        if (url.origin === window.location.origin && /\/cart(?:\/|$)/.test(url.pathname)) rememberCurrentPage();
      } catch (_) {}
    }, true);
    document.addEventListener('submit', rememberCurrentPage, true);
    document.addEventListener('cart:updated', updateLinks);
    document.addEventListener('shopify:section:load', updateLinks);
    window.addEventListener('pagehide', rememberCurrentPage);
    window.addEventListener('hashchange', rememberCurrentPage);
    window.addEventListener('popstate', rememberCurrentPage);
    window.addEventListener('pageshow', () => {
      rememberCurrentPage();
      updateLinks();
    });
    window.navigation?.addEventListener('navigate', rememberCurrentPage);
    rememberCurrentPage();
    updateLinks();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["starbond-gift-popup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('starbond-cart-gift-popup')) {
  customElements.define('starbond-cart-gift-popup', class extends HTMLElement {
    connectedCallback() {
      this.schedule = this.schedule.bind(this);
      this.frame = 0;
      this.wasVisible = false;
      this.popup = null;
      this.consentHost = null;
      this.shadow = null;
      this.banner = null;
      this.shadowAttempts = 0;
      this.sliders = new WeakSet();
      this.documentObserver = new MutationObserver(this.schedule);
      this.documentObserver.observe(document.body, { childList: true, subtree: true });
      this.popupObserver = new MutationObserver(this.schedule);
      this.consentObserver = new MutationObserver(this.schedule);
      this.resizeObserver = new ResizeObserver(this.schedule);
      window.addEventListener('resize', this.schedule, { passive: true });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true });
      document.addEventListener('fg-gifts:show-slider', this.schedule);
      customElements.whenDefined('csm-cookie-consent').then(() => {
        if (this.isConnected) this.schedule();
      });
      this.schedule();
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.focusFrame);
      clearTimeout(this.shadowRetry);
      this.documentObserver?.disconnect();
      this.popupObserver?.disconnect();
      this.consentObserver?.disconnect();
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.schedule);
      window.visualViewport?.removeEventListener('resize', this.schedule);
      document.removeEventListener('fg-gifts:show-slider', this.schedule);
      this.popup?.style.removeProperty('--sb-gift-available-height');
      this.popup?.classList.remove('sb-gift-popup-constrained');
    }

    schedule() {
      if (!this.frame && this.isConnected) {
        this.frame = requestAnimationFrame(() => this.update());
      }
    }

    observeConsent() {
      const host = document.querySelector('csm-cookie-consent');
      if (host !== this.consentHost) {
        this.consentObserver.disconnect();
        this.resizeObserver.disconnect();
        clearTimeout(this.shadowRetry);
        this.consentHost = host;
        this.shadow = null;
        this.banner = null;
        this.shadowAttempts = 0;
        if (host) this.consentObserver.observe(host, {
          attributes: true,
          attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
        });
      }
      if (host?.shadowRoot && this.shadow !== host.shadowRoot) {
        this.shadow = host.shadowRoot;
        this.consentObserver.observe(this.shadow, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
        });
      } else if (host && !this.shadow && this.shadowAttempts++ < 50) {
        clearTimeout(this.shadowRetry);
        this.shadowRetry = setTimeout(this.schedule, 100);
      }
      const banner = this.shadow?.querySelector('.csm-cmp-bar.cc-bottom') || null;
      if (banner !== this.banner) {
        this.resizeObserver.disconnect();
        this.banner = banner;
        if (banner) this.resizeObserver.observe(banner);
      }
    }

    availableHeight() {
      let height = window.innerHeight;
      if (!this.banner) return height;
      const rect = this.banner.getBoundingClientRect();
      const style = getComputedStyle(this.banner);
      if (rect.width > 0 && rect.height > 0 && rect.top > 0 && rect.top < height
        && style.display !== 'none' && style.visibility !== 'hidden'
        && Number(style.opacity) > 0) {
        height = Math.max(144, rect.top - 12);
      }
      return height;
    }

    update() {
      this.frame = 0;
      if (!this.isConnected) return;
      this.observeConsent();
      const popup = document.getElementById('freegifts-main-popup-container');
      if (popup !== this.popup) {
        this.popupObserver.disconnect();
        this.popup = popup;
        if (popup) this.popupObserver.observe(popup, { attributes: true, attributeFilter: ['class'] });
      }
      const visible = Boolean(popup?.classList.contains('sca-is-visible-fg'));
      if (visible) this.configureSliders(popup);
      if (popup) {
        const height = this.availableHeight();
        const value = visible ? `${height}px` : '';
        if (popup.style.getPropertyValue('--sb-gift-available-height') !== value) {
          if (value) popup.style.setProperty('--sb-gift-available-height', value);
          else popup.style.removeProperty('--sb-gift-available-height');
        }
        const constrained = visible && height < 480;
        if (popup.classList.contains('sb-gift-popup-constrained') !== constrained) {
          popup.classList.toggle('sb-gift-popup-constrained', constrained);
        }
        const close = popup.querySelector('.bogos-slider-close-btn');
        if (close && this.dataset.closeLabel && close.getAttribute('aria-label') !== this.dataset.closeLabel) {
          close.setAttribute('aria-label', this.dataset.closeLabel);
        }
      }
      if (this.wasVisible && !visible) this.returnToCheckout();
      this.wasVisible = visible;
    }

    configureSliders(popup) {
      popup.querySelectorAll('.glider.bogos-offer-gift-items-container').forEach(element => {
        const glider = element._glider;
        if (!glider || this.sliders.has(glider)
          || typeof glider.setOption !== 'function' || typeof glider.refresh !== 'function') return;
        this.sliders.add(glider);
        glider.setOption({
          slidesToShow: 2.16,
          slidesToScroll: 1,
          responsive: [{ breakpoint: 750, settings: { slidesToShow: 4, slidesToScroll: 4 } }],
        }, true);
        glider.refresh(true);
      });
    }

    returnToCheckout() {


      cancelAnimationFrame(this.focusFrame);
      this.focusFrame = requestAnimationFrame(() => {
        this.focusFrame = requestAnimationFrame(() => {
          if (!this.isConnected || this.popup?.classList.contains('sca-is-visible-fg')) return;
          const checkout = document.querySelector('main button[name="checkout"]:not([disabled])')
            || document.querySelector('#checkout:not([disabled])')
            || document.querySelector('form[action*="/cart"] [name="checkout"]:not([disabled])');
          if (!checkout || !checkout.getBoundingClientRect().height) return;
          checkout.focus({ preventScroll: true });
          const rect = checkout.getBoundingClientRect();
          window.scrollBy(0, rect.top + rect.height / 2 - this.availableHeight() / 2);
        });
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["starbond-kfs-buy-button"] && !Shopify.designMode) return;
  try {
    customElements.whenDefined('product-form').then(() => {
    if (customElements.get('starbond-kfs-product-form')) return;
    const NativeProductForm = customElements.get('product-form');
    class StarbondKfsProductForm extends NativeProductForm {}

    customElements.define('starbond-kfs-product-form', StarbondKfsProductForm, { extends: 'form' });
  });
  } catch(e) { console.error(e); }
})();

})();
